import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { validatenull } from "@/util/validate";
import { mapGetters } from "vuex";
export default {
  name: "top-lock",
  data: function data() {
    return {
      box: false,
      form: {
        passwd: ""
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  computed: _objectSpread({}, mapGetters(["lockPasswd"])),
  props: [],
  methods: {
    handleSetLock: function handleSetLock() {
      var _this = this;

      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this.$store.commit("SET_LOCK_PASSWD", _this.form.passwd);

          _this.handleLock();
        }
      });
    },
    handleLock: function handleLock() {
      var _this2 = this;

      if (validatenull(this.lockPasswd)) {
        this.box = true;
        return;
      }

      this.$store.commit("SET_LOCK");
      setTimeout(function () {
        _this2.$router.push({
          path: "/lock"
        });
      }, 100);
    }
  },
  components: {}
};